import { render } from "./DatosPropietarioRepresentanteComponent.vue?vue&type=template&id=17b88478"
import script from "./DatosPropietarioRepresentanteComponent.vue?vue&type=script&lang=js"
export * from "./DatosPropietarioRepresentanteComponent.vue?vue&type=script&lang=js"

import "./DatosPropietarioRepresentanteComponent.vue?vue&type=style&index=0&id=17b88478&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__